import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
//import { GetCommonBaseURL } from '../axiosComponent/read';
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";

const MyPackingType = ({
  field: { name },
  form: { setFieldValue },
  ...props
}) => {
  const [content, setcontent] = useState([]);
  const [loading, setloading] = useState(false);
  useEffect(() => {
    // $("#searchType .dropdown").removeClass("dropdown")
    setloading(true);
    allAxiosCommonRequest({
      url: "masters/packaging_type",
      method: "get",
    }) //CommonGetApi({ url: 'branch' })
      .then((data) => {
        setcontent(data.data.resultSet);
        setloading(false);
      })
      .catch((error) => console.log(error));

    /* GetCommonBaseURL({
      newUrl: "masters/packaging_type",
      response: (data) => {
        // let cont = data.data.data
        setcontent(data.data.resultSet);
        setloading(false);
      },
    }); */
  }, []);
  let options = [];
  if (content.length > 0) {
    content.map((object, index) => {
      let temp = {};
      temp.key = object.packagingTypeId;
      temp.text = `${object.packagingType}`;
      temp.value = object.packagingTypeCode;
      return (options[index] = temp);
    });
  }
  let handleChange = (value, data) => {
    setFieldValue(name, data.value);
  };
  return (
    <Dropdown
      selection
      search
      scrolling
      loading={loading ? true : false}
      style={{ width: "100%" }}
      onChange={handleChange}
      options={options}
      // id="searchType"
      noResultsMessage="Search for Result"
      {...props}
    />
  );
};

export default MyPackingType;
